const getFileExtension = filename => {

  const filenameArray = filename.split('.');
  return filenameArray[filenameArray.length - 1].toLowerCase();
};

export default getFileExtension;

